import { getProject, ProjectId } from 'owa-timestream-store';

export default function getProjectName(projectId: ProjectId) {
    return getProject(projectId).name;
}
